import styled from 'styled-components';

import InputSimple from '@r1-frontend/ui-react/components/inputSimple';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const Wrapper = styled.div`
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 24px;
    border-radius: ${BorderRadius.OuterBlockRadius};
    background-color: ${COLORS.BgSurface};

    @media (max-width: ${wideBreakpoints.mobile}) {
        padding: 16px;
        border-radius: ${BorderRadius.componentRadius};
        flex-direction: column;
        flex-wrap: nowrap;
        width: 100%;
        align-items: baseline;
        gap: 12px;
    }
`;

export const Label = styled.div`
    flex-direction: column;
`;

export const Text = styled.p`
    ${FONTS.MediumS};
    color: ${COLORS.TextPrimary};

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.MediumXS};
    }
`;

export const Info = styled.p<{ isValid: boolean }>`
    ${FONTS.S};
    color: ${({ isValid }) => isValid ? COLORS.TextPrimary : COLORS.Error};

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.XS};
    }
`;

export const InputBonuses = styled(InputSimple)<{ disabled: boolean }>`
    position: relative;
    max-width: 120px;
    margin: 0;

    &:after {
        content: '';
        position: absolute;
        top: 12px;
        right: 16px;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        background-image: url('/static/images/loyalty/loyalty-logo.png');
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        opacity: ${({ disabled }) => disabled ? .5 : 1};
        overflow: hidden;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        max-width: unset;
        width: 100%;
    }
`;
